import { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { GroupMember } from '../../../types/groupDetail';

interface BulkActionsBarProps {
  selectedMembers: GroupMember[];
  onBulkRoleChange: (role: 'Member' | 'Assistant Leader' | 'Group Leader') => void;
  onBulkRemove: () => void;
  onClearSelection: () => void;
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedMembers,
  onBulkRoleChange,
  onBulkRemove,
  onClearSelection,
}) => {
  const [isBulkMenuOpen, setIsBulkMenuOpen] = useState(false);

  return (
    <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-gray-900">
          {selectedMembers.length} selected
        </span>
        <button
          onClick={onClearSelection}
          className="inline-flex items-center justify-center gap-2 w-[38px] h-[38px] md:w-auto md:h-auto md:px-3 md:py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-sm hover:bg-gray-50 whitespace-nowrap"
        >
          <LucideIcons.X size={16} />
          <span className="hidden md:inline">Clear</span>
        </button>
        <div className="relative">
          <button
            onClick={() => setIsBulkMenuOpen(!isBulkMenuOpen)}
            className="inline-flex items-center justify-center gap-2 w-[38px] h-[38px] md:w-auto md:h-auto md:px-3 md:py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-sm hover:bg-gray-50 whitespace-nowrap"
          >
            <LucideIcons.UserCog size={16} />
            <span className="hidden md:inline">Set Role</span>
          </button>
          {isBulkMenuOpen && (
            <>
              <div
                onClick={() => setIsBulkMenuOpen(false)}
                className="fixed inset-0 z-10"
              />
              <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-20">
                {(['Member', 'Assistant Leader', 'Group Leader'] as const).map((role) => (
                  <button
                    key={role}
                    onClick={() => {
                      onBulkRoleChange(role);
                      setIsBulkMenuOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 first:rounded-t-md last:rounded-b-md"
                  >
                    {role}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
        <button
          onClick={onBulkRemove}
          className="inline-flex items-center justify-center gap-2 w-[38px] h-[38px] md:w-auto md:h-auto md:px-3 md:py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-sm hover:bg-gray-50 whitespace-nowrap"
        >
          <LucideIcons.UserX size={16} />
          <span className="hidden md:inline">Remove</span>
        </button>
    </div>
  );
};
